<template>
  <div class="result">
    <!-- <TodayResult />
    <HistoryResults :length="5" />
    <div class="text-right mb-3 mt-2">
      <router-link :to="{name: 'Results'}">ຜົນການອອກເລກລາງວັນເພີ່ມເຕີມ...</router-link>
    </div>

    <MidBanner /> -->

    <TodayResultVIP />
    <HistoryResultsVIP :length="30" />
    <!-- <div class="text-right mb-3 mt-2">
      <router-link :to="{name: 'Vip'}">ຜົນການອອກເລກລາງວັນເພີ່ມເຕີມ...</router-link>
    </div> -->
  </div>
</template>
<script>
// import MidBanner from './components/MidBanner'
// import TodayResult from './components/TodayResult'
// import HistoryResults from './components/HistoryResults'

import TodayResultVIP from './components/TodayResultVIP'
import HistoryResultsVIP from './components/HistoryResultsVIP'

export default {
  components: {
    // MidBanner,
    // TodayResult,
    // HistoryResults,
    TodayResultVIP,
    HistoryResultsVIP
  }
}
</script>
<style lang="scss">
.result {

}
</style>
